import * as Pages from './pages'
import * as Perms from './perms'

export default {
  pages: Pages,
  perms: Perms,
}
